var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var device = require('lib/device.js');

function TextEffects() {
  this.init();
}

TextEffects.prototype.init = function() {
  $('.callouts').not('[data-callout-count]').each(function() {
    var $el = $(this);

    if(!$el.closest('.product-info').length && !$el.attr('data-callout-count')) {
      new Callouts(this);
    }
  });

  $('[data-heading-animation]').not('.heading-animation-on').each(function() {
    new HeadingAnimation(this);
  });
}

module.exports = TextEffects;

function Callouts(el) {
  this.$el = $(el);
  this.$facts = this.$el.children();
  this.active = 0;
  this.count = this.$facts.length;
  this.timer = 0;

  this.$el.attr('data-callout-count', this.count);

  this.timer = setTimeout(this.next.bind(this), 4000);
}

Callouts.prototype.next = function() {
  clearTimeout(this.timer);
  
  this.active++;

  if(this.active >= this.count) {
    this.active = 0;
  }

  this.$el.css('transform', 'translateX(-'+(this.active / this.count * 100)+'%)');

  this.timer = setTimeout(this.next.bind(this), 4000);
}

function HeadingAnimation(el) {
  if(device.isDefinitelyMobile) {
    return;
  }

  this.$el = $(el);

  this.$el.addClass('heading-animation-on');
  
  this.t = new TimelineLite({
    onComplete: this.finish.bind(this)
  });
  this.items = [];

  this.t.pause();

  this.$el.find('h1, h2, h3, h4').each(function(index, headingEl) {
    this.addHeading(headingEl);
  }.bind(this));

  this.$el.find('p:has(a.vsc-button)').each(function(index, paragraphEl) {
    this.addParagraph(paragraphEl);
  }.bind(this));

  this.$el.one('scroll-in.vsc-scroll slide-in.vsc-slide', function() {
    this.t.play();
  }.bind(this));
}

HeadingAnimation.prototype.addHeading = function(headingEl) {
  var $h = $(headingEl);

  if($h.is('h4')) {
    $h.wrapInner('<span></span>');
  } else {
    var parts = $h.html().split(' ');

    for(var i = 0; i < parts.length; i++) {
      if(parts[i].indexOf('<') !== 0) {
        parts[i] = '<span>'+parts[i]+'</span>';
      }
    }

    $h.html(parts.join(' '));
  }

  $h.addClass('heading-split');

  $h.children().each(function(index, word) {
    var strong = word.tagName.toLowerCase() == 'strong';
    var dur = strong ? .5 : .3;
    var initialScale = strong ? .5 : .75;
    var pos = (index !== 0) ? '-=.05' : null;

    this.t.fromTo(word, dur, {
      opacity: 0,
      scale: initialScale
    }, {
      opacity: 1,
      scale: 1,
      ease: Back.easeOut
    }, pos);
  }.bind(this));
}

HeadingAnimation.prototype.addParagraph = function(paragraphEl) {
  var $p = $(paragraphEl);
  $p.addClass('heading-animation-p');

  this.t.fromTo($p[0], .6, {
    opacity: 0,
    scale: .75
  }, {
    opacity: 1,
    scale: 1,
    ease: Back.easeOut
  });
}

HeadingAnimation.prototype.finish = function() {
  this.$el.addClass('heading-animation-done');
}
